import { AppDisplay } from '@ui/applications';
import { FilterComponent } from '@ui/table-modifier/filters';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import { OptionFilter } from '@periscopes/general/filters';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { useDataSecurityApps } from '@hooks';
import React, { useMemo } from 'react';
import { sortBy, uniqBy } from 'lodash';
export const AppNameFilter = (props) => {
    const { format, id, label, onChange, value } = props;
    const apps = useDataSecurityApps(false, false, false);
    const options = useMemo(() => sortBy(uniqBy(apps.map((app) => ({
        key: app.applicationId,
        label: app.name,
        value: app.name
    })), (app) => app.label), (app) => app.label), [apps]);
    return (React.createElement(FilterComponent, Object.assign({}, props, { tagProps: {
            value: options
                .filter((option) => value === null || value === void 0 ? void 0 : value.includes(option.value))
                .map((option) => option.label)
                .join(', ')
        } }),
        React.createElement(OptionFilter, { className: 'filter', id: getFilterId(id), maxTagCount: 'responsive', mode: 'multiple', onChange: (values) => {
                onChange({
                    [id]: {
                        format,
                        value: values !== null && values !== void 0 ? values : []
                    }
                });
            }, optionRender: (option) => React.createElement(AppDisplay, { appId: option.key, hideLabel: true }), options: options, placeholder: PLACEHOLDERS_COPY.FILTER_BY(label !== null && label !== void 0 ? label : ''), showArrow: true, value: value })));
};
